<div>
  <p>このURLは有効期限が過ぎています</p>
  <p *ngIf="expirationDate !== undefined">{{displayExpirationDate}}</p>
</div>
